
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import gateway from "@/lib/request/gateway";
import Auth from "@/lib/common/auth";
import ImageCropper from "./image-cropper.vue";

@Component({
  components: { ImageCropper }
})
export default class HinaUpload extends Vue {
  @Prop({ default: "image", type: String }) private type!: "image" | "video";
  @Prop({ default: "", type: String }) private value!: string;
  @Prop({ default: 2, type: Number }) private size!: number;
  @Prop({ default: true, type: Boolean }) private showInfo!: boolean;
  @Prop({ default: "" }) acceptText!: string;
  @Prop({ default: false, type: Boolean }) private cutImage!: boolean;
  @Prop({
    default: "上传内容：750x1624px，上传格式：JPG、JPEG、PNG",
    type: String
  })
  private info!: string;

  loading = false;
  imageUrl = "";
  uploaded = 0;
  uploadTotal = 0;
  file: File | null = null;

  get token() {
    return Auth.token;
  }

  get percent() {
    return Math.floor((this.uploaded / this.uploadTotal) * 100) || 0;
  }

  @Watch("value", { immediate: true })
  onValueChange(val: string) {
    this.imageUrl = val;
  }

  onChange(e: any) {
    if (!e.srcElement.files[0]) return;

    const file: File = e.srcElement.files[0];

    const isJPG =
      file.type === "image/jpeg" ||
      file.type === "image/jpg" ||
      file.type === "image/png";

    const isMp4 = file.type.includes("mp4") || file.type.includes("MP4");

    const isLtSize = file.size / 1024 / 1024 < this.size;

    if (!isJPG && this.type === "image") {
      this.$message.error("上传图片只能是 JPG/JPEG/PNG 格式!");
      this.loading = false;
      return false;
    }

    if (!isMp4 && this.type === "video") {
      this.$message.error("请上传MP4格式视频");
      this.loading = false;
      return false;
    }

    if (!isLtSize) {
      this.$message.error("上传文件过大!");
      this.loading = false;
      return false;
    }

    if (this.cutImage && this.type === "image") {
      this.file = file;
      return;
    }

    this.uploadFile({
      filename: "test",
      file: file
    });
  }

  // 裁剪后的图片
  checkedImg = "";

  base64ToFile(base64: any, fileName: string) {
    // 将base64按照 , 进行分割 将前缀  与后续内容分隔开
    const data = base64.split(",");
    // 利用正则表达式 从前缀中获取图片的类型信息（image/png、image/jpeg、image/webp等）
    const type = data[0].match(/:(.*?);/)[1];
    // 从图片的类型信息中 获取具体的文件格式后缀（png、jpeg、webp）
    const suffix = type.split("/")[1];
    // 使用atob()对base64数据进行解码  结果是一个文件数据流 以字符串的格式输出
    const bstr = window.atob(data[1]);
    // 获取解码结果字符串的长度
    let n = bstr.length;
    // 根据解码结果字符串的长度创建一个等长的整形数字数组
    // 但在创建时 所有元素初始值都为 0
    const u8arr = new Uint8Array(n);
    // 将整形数组的每个元素填充为解码结果字符串对应位置字符的UTF-16 编码单元
    while (n--) {
      // charCodeAt()：获取给定索引处字符对应的 UTF-16 代码单元
      u8arr[n] = bstr.charCodeAt(n);
    }
    // 利用构造函数创建File文件对象
    // new File(bits, name, options)
    const file = new File([u8arr], `${fileName}.${suffix}`, {
      type: type
    });
    // 将File文件对象返回给方法的调用者
    return file;
  }

  confirm(base64: any) {
    this.checkedImg = base64;
    this.uploadFile({
      filename: "test",
      file: this.base64ToFile(base64, "test")
    });
  }

  uploadFile(data: { filename: string; file: File }) {
    const { file } = data;

    this.loading = true;

    // 上传图片到oss
    gateway.anonymousGetPostPolicy(file.name).then((postRes: any) => {
      if (postRes) {
        const tempUrl = postRes.cdn + "/" + encodeURIComponent(postRes.dir);
        const config: any = {
          onUploadProgress: (progressEvent: any) => {
            this.uploaded = progressEvent.loaded;
            this.uploadTotal = progressEvent.total;
          }
        };
        gateway
          .upload(postRes, file, config)
          .then((res: any) => {
            console.log("upload res : ", res);
          })
          .finally(() => {
            this.imageUrl = tempUrl;
            this.$emit("update:value", this.imageUrl);
            this.$emit("change", this.imageUrl);
            this.loading = false;
            this.uploaded = 0;
            this.uploadTotal = 0;
          });
      }
    });
  }

  priview() {
    return;
  }

  delImg() {
    this.$emit("update:value", "");
    this.$emit("change", "");
  }

  downloadImg() {
    this.openImageInNewTab();
  }

  openImageInNewTab() {
    if (!this.imageUrl) return;

    fetch(this.imageUrl)
      .then(response => response.blob())
      .then(blob => {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = objectUrl;

        // Set appropriate file extension based on type
        const extension = this.type === "video" ? "mp4" : "jpg";
        const timestamp = new Date().getTime();
        link.download = `${this.type}_${timestamp}.${extension}`;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(objectUrl);
      })
      .catch(error => {
        console.error("Download failed:", error);
        window.location.href = this.imageUrl;
      });
  }
}
